import React from 'react';
import PropTypes from 'prop-types';
import { FormattedNumber } from 'react-intl';

import { getKilogramsAndGramsFromGrams } from 'ui-components/components/weight-input/helpers';

import { UNIT_GRAM, UNIT_KILOGRAM, INTL_NUMBER_STYLE_UNIT, INTL_NUMBER_UNIT_DISPLAY_SHORT } from './intl-unit-formatting-service';
import style from './weight-formatted-message.module.less';

export const WeightFormattedMessage = ({ weight }) => {
  const { kilograms, grams } = getKilogramsAndGramsFromGrams(weight);
  return (
    <>
      <FormattedNumber
        maximumFractionDigits={2}
        style={INTL_NUMBER_STYLE_UNIT}
        unit={UNIT_KILOGRAM}
        unitDisplay={INTL_NUMBER_UNIT_DISPLAY_SHORT}
        value={kilograms}
      />
      <span className={style['weight-wrapper']}>
        <FormattedNumber
          maximumFractionDigits={2}
          style={INTL_NUMBER_STYLE_UNIT}
          unit={UNIT_GRAM}
          unitDisplay={INTL_NUMBER_UNIT_DISPLAY_SHORT}
          value={grams}
        />
      </span>
    </>
  );
};

WeightFormattedMessage.propTypes = {
  weight: PropTypes.number.isRequired,
};
